import { gql } from '@apollo/client';
const UPDATE_MODEL_SPECIFICATION_VARIANTS = gql `
  mutation UpdateModelVariants($variantsQuantity: [[ID]]!) {
    updateModelSpecificationVariants(variantsQuantity: $variantsQuantity) {
      modelSpecification {
        id
        variants {
          edges {
            node {
              id
              isActive
              quantity
            }
          }
        }
        totalQuantity
      }
    }
  }
`;
export default UPDATE_MODEL_SPECIFICATION_VARIANTS;
